import React, { Component } from 'react'
import {  Layout,Button,Typography  } from 'antd';
import { Link } from "react-router-dom";
import relogin from '../../assets/image/404.png'
import "./errorInfo.scss";
const { Title,Text } = Typography;

export default class ErrorPages extends Component {

  reloadpage=()=>{
    //location.reload();
    //location.reload();
    window.location.reload();
  }
  render() {
    return (
      <Layout className='laystyle'>
        <div className='laycontent'>
          <div className='contentleft'>
            <img alt="" src={relogin} />
          </div>
          <div className='contentright'>
            <Title level={3}>抱歉，您访问的页面不存在
            </Title>
            <Text className='CRtext' style={{marginBottom:'0px'}}>
              可能的原因：网址输入错误、网址已失效
            </Text>
            <Text className='CRtext'>
              请检查地址是否正确，或刷新页面
            </Text>
            <Link to='/pages' className='CRbutton'>
              <Button>返回首页</Button>
            </Link>
            <Button style={{marginLeft:'60px'}} onClick={this.reloadpage}>&nbsp;&nbsp;&nbsp;刷新&nbsp;&nbsp;&nbsp;</Button>
          </div>
        </div>
      </Layout>
    )
  }
}